<template>
  <b-row>
    <b-col cols="12">
      <regularization-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import RegularizationAddForm from './RegularizationAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    RegularizationAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
